import {Spawn, MapState} from 'src/common/map/MapState';
import {Location} from 'src/common/map/Location';
import {StateCtor} from 'src/game/states/State';
import {Game} from 'src/game/Game';
import SelectState from 'src/game/states/SelectState';
import PlaceState from 'src/game/states/PlaceState';
import FireState from 'src/game/states/FireState';
import BuildState from 'src/game/states/BuildState';
import EndState from 'src/game/states/EndState';
import {GameState, GameMode} from './GameMode';

export class ClassicGameMode implements GameMode {
    public game: Game;
    public readonly states: {[key in GameState]: StateCtor} = {
        select: SelectState,
        place: PlaceState,
        fire: FireState,
        build: BuildState,
        end: EndState,
    };
    public readonly startState: GameState = 'select';
    public readonly showBuildability: boolean = true;

    public possibleSpawnsForPlayer(playerIndex: number): Spawn[] {
        return this.map.spawnsOwnedByPlayer(playerIndex);
    }

    public canBuildAtLocation(map: MapState, tiles: Location[], playerIndex: number): boolean {
        return tiles.every(
            loc => this.game.buildability.minDistanceGrids[playerIndex][loc.y][loc.x] < 20
        );
    }

    private get map(): MapState {
        return this.game.map;
    }
}



// WEBPACK FOOTER //
// ./src/common/modes/ClassicGameMode.ts